import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";

export default {
    methods: {
        async getServiceAgreementListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getServiceAgreementListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + 'ServiceAgreement', { filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },

        async getServiceAgreementByMachineId(machineId) {
            var meta = { clientApiMethod: 'getServiceAgreementByMachineId', input: { machineId: machineId } }
            var response = await client().get(store.state.apiRouteRoot + "ServiceAgreement/" + machineId, { meta: meta })
            return response?.data;
        },

        async setServiceAgreement(machineId, agreement, agreementIsActive) {
            var meta = {
                clientApiMethod: 'setServiceAgreement',
                input: { agreement: agreement },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.service_agreement.service_agreement") })
            }
            var response = await client().post(store.getters.ApiRoute("ServiceAgreement", machineId), agreement, { params: { agreementIsActive }, meta: meta })
            return response?.data;
        },

    }
}